export const forecastTab = [
    {
        literalTab: "20698",
        url: "cedefop",
        subTabs: [
            {
                literalTab: "20752",
                url: "employment-growth",
                chartType: [
                    {chart:"20001", title: "20703", chartIndicator: "423", legend: "20713"}
                ]
            },
            {
                literalTab: "20753",
                url: "employment-growth-sector",
                chartType: [
                    {type:"percentage", chart:"20002", title: "20717", chartIndicator: "425", chartIndicator2: "424", legend: "20718", sector: ['1', '2', '3', '4', '6', '7', '18'], splitName: "20648"}
                ]
            },
            {
                literalTab: "20754",
                url: "labour-force-growth-age",
                chartType: [
                    {type:"percentage", chart:"20003", title: "20744", chartIndicator: "427", chartIndicator2: "426", legend: "20745", age: ['4','7','8','9','10','11','12','13','14','15','16','17'], splitName: "20650"}
                ]
            },
            {
                literalTab: "20755",
                url: "top-sectors-employment",
                chartType: [
                    {chart:"20004", title: "20746", chartIndicator: "428", legend: "20747", totalValue: true, onlyOneCountry: true, splitName: "20648"}
                ]

            },
            {
                literalTab: "20756",
                url: "top-occupations-employment",
                chartType: [
                    {chart:"20005", title: "20748", chartIndicator: "429", legend: "20749", totalValue: true, onlyOneCountry: true, splitName: "20779"}
                ]
            },
            {
                literalTab: "20757",
                url: "job-openings-by-occupation",
                chartType: [
                    {chart:"20006", title: "20750", chartIndicator: "430", legend: "20751", occupation: ['4','6','9','1','7','8','2','5','3','10'], onlyOneCountry: true, splitName: "20779"}
                ]
            }
        ]
    }
]

export const regulationsTab = [
    {
        url: "introduction-safety",
        literalTab: "20033",
        indicator: "412",
        textIndex: "1"
    },
    {
        url: "european-directives",
        literalTab: "20034",
        indicator: "413",
        textIndex: "2"
    },
    {
        url: "eu-guidelines",
        literalTab: "20035",
        indicator: "414",
        textIndex: "3"
    },
    {
        url: "eu-standards",
        literalTab: "20036",
        indicator: "415",
        textIndex: "4"
    },
    {
        url: "national-legislation",
        literalTab: "20037",
        indicator: "416",
        textIndex: "5"
    },
    {
        url: "evaluation-of-compliance",
        literalTab: "20038",
        indicator: "417",
        textIndex: "6"
    },
    {
        url: "european-court-decisions",
        literalTab: "20039",
        indicator: "418",
        textIndex: "7"
    }
]

export const countryProfile = [
    {
        url: "basic-information",
        literalTab: "20246",
        indicator: "46",
        textIndex: "1"
    },
    {
        url: "background",
        literalTab: "20247",
        indicator: "47",
        textIndex: "2"
    },
    {
        url: "characteristics-and-objectives",
        literalTab: "20248",
        indicator: "48",
        textIndex: "3"
    },
    {
        url: "details-and-activity",
        literalTab: "20249",
        indicator: "49",
        textIndex: "4"
    },
    {
        url: "actors-and-stakeholders",
        literalTab: "20250",
        indicator: "50",
        textIndex: "5"
    },
    {
        url: "resources-and-timeframe",
        literalTab: "20251",
        indicator: "98",
        textIndex: "6"
    },
    {
        url: "evaluation",
        literalTab: "20252",
        indicator: "51",
        textIndex: "7"
    },
    {
        url: "relationship-to-eu-strategic-framework",
        literalTab: "20253",
        indicator: "99",
        textIndex: "8"
    }
]

export const workerInvolvementTabs = [
    { 
        literalTab: "22015", 
        chartType: [
            {type: "esener", chart:"20106", title: "22015", chartIndicator: '553', sector: null, answers: null, legend: null, datasetLiteral: "875"},
            {type: "ewcs", chart:"20069", title: "22015", chartIndicator: '75', sector: null, answers: null, legend: null, datasetLiteral:"874"}
        ]
    }
]

export const overallOpinion = [
    { 
        url:"job-satisfaction",
        literalTab: "24618",
        chartType: [
            {type: "ewcs", title: "22134", chart: "20040", chartIndicator: "65", sector: null, answers: ['10','11','12','13'], sortByAnswer: ["13","12"], legend: "20580", datasetLiteral: "874"},
            {type: "flash", title: "20040", chart: "20127", chartIndicator: "389", sector: null, answers: ['13','109','11','10'], sortByAnswer: ["13","109"], legend: "20041", datasetLiteral: "876"}
        ]
    },
    { 
        url:"health-at-risk",
        literalTab: "24619",
        indicator:"66"
    },
    {
        url:"satisfaction-health-safety",
        literalTab: "24646",
        chartType: [{type: "flash", title: "20583", chart: "20126", chartIndicator: "391", sector: null, answers: ['10','11','109','13'], legend: "20367", datasetLiteral: "876"}]
    }
]

export const mentalRisk = [
    {
        literalTab: "20871",
        url: "risk-factors",
        subTabs: [
            { 
                url:"time-pressure",
                literalTab: "20669",
                chartType: [
                    {type: "osh-pulse", title: "20879", chart: "20159", chartIndicator: "456", sortByAnswer: ["value"], legend: "20880", columns:['Country'], datasetLiteral: "1025", hasTrend: false},
                    {type: "esener", title: "22136" , chart: "20096", chartIndicator: "514", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20585", columns:['Country','Yes (%)','No (%)'], datasetLiteral: "875", hasTrend: true},
                    {type: "ewcs", title: "22179", chart: "20073", chartIndicator: "83", answers: ["14", "15", "16"], sortByAnswer: ["14", "16"], legend: "20584", columns:['Country','All the time (%)','¼ and ¾ of the time (%)','Never (%)'], datasetLiteral: "874", hasTrend: false},
                    {type: "flash", title: "20369", chart: "20125", chartIndicator: "392", answers: ['10','11','109','13'], sortByAnswer: ["13","109"], legend: "20371", columns:['Country','Very satisfied (%)','Fairly satisfied (%)','Not very satisfied (%)','Not at all satisfied (%)'], datasetLiteral: "876", hasTrend: false}
                ]
            },
            {
                url:"poor-communication",
                literalTab: "20670",
                chartType: [
                    {type: "osh-pulse", title: "20881", chart: "20160", chartIndicator: "457", sortByAnswer: ["value"], legend: "20882", columns:['Country'], datasetLiteral: "1025", hasTrend: false},
                    {type: "esener", title: "22137", chart: "20097", chartIndicator: "515", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20587", columns:['Country','Yes (%)','No (%)'], datasetLiteral: "875", hasTrend: true},
                    {type: "ewcs", title: "22180", chart: "20074", chartIndicator: "84", answers: ["17"], sortByAnswer: ["17"], legend: "20586", columns:['Country','Value (%)'], datasetLiteral:"874", hasTrend: false}
                ]
            },
            {
                url:"influence",
                literalTab: "20671", 
                chartType: [
                    {type: "osh-pulse", title: "20883", chart: "20161", chartIndicator: "458", sortByAnswer: ["value"], legend: "20884", columns:['Country'], datasetLiteral: "1025", hasTrend: false},
                    {type: "ewcs", chart:"20075", title: "22181", chartIndicator: "85", sector: null, answers: ["18", "19", "20"], sortByAnswer: ["18","20"], legend: "20588", columns:['Country','Always or most of the time (%)','Sometimes (%)','Rarely or never (%)'], datasetLiteral:"874", hasTrend: true}
                ]
            },
            {
                url:"fear-of-job-loss",
                literalTab: "20672",
                chartType: [
                    {type: "esener", title: "22139", chart: "20098", chartIndicator: "516", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20591", columns:['Country','Yes (%)','No (%)'], datasetLiteral: "875", hasTrend: false},
                    {type: "ewcs", title: "22182", chart: "20076", chartIndicator: "86", answers: ["21", "22", "23"], sortByAnswer: ["21","23"], legend: "20590", columns:['Country','Agree (%)','Neither agree or disagree (%)','Disagree (%)'], datasetLiteral:"874", hasTrend: true}
                ]
            },
            {
                url:"difficult-clients",
                literalTab: "20673",
                chartType: [
                    {type: "osh-pulse", title: "20885", chart: "20162", chartIndicator: "459", sortByAnswer: ["value"], legend: "20886", columns:['Country'], datasetLiteral: "1025", hasTrend: false},
                    {type: "esener", title: "22140", chart: "20099", chartIndicator: "517", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20593", columns:['Country','Yes (%)','No (%)'], datasetLiteral: "875", hasTrend: true},
                    {type: "ewcs", title: "22183", chart: "20077", chartIndicator: "87", answers: ["14", "15", "16"], sortByAnswer: ["14","16"], legend: "20592", columns:['Country','All the time (%)','¼ and ¾ of the time (%)','Never (%)'], datasetLiteral:"874", hasTrend: true}
                ]
            },
            {
                url:"working-hours",
                literalTab: "20674",
                chartType: [
                    {type: "esener", title: "22141", chart: "20100", chartIndicator: "518", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20595", columns:['Country','Yes (%)','No (%)'], datasetLiteral: "875", hasTrend: true},
                    {type: "ewcs", title: "22184", chart: "20078", chartIndicator: "88", answers: ["24", "25"], sortByAnswer: ["25"], legend: "20594", columns:['Country','Yes (%)','No (%)'], datasetLiteral:"874", hasTrend: true}
                ]
            },
            {
                url:"discrimination",
                literalTab: "20675",
                chartType: [
                    {type: "osh-pulse", title: "20887", chart: "20163", chartIndicator: "460", sortByAnswer: ["value"], legend: "20888", columns:['Country'], datasetLiteral: "1025", hasTrend: false},
                    {type: "ewcs", title:"22185", chart: "20079", chartIndicator: "89", answers: ["1","2"], sortByAnswer: ["1"], legend: "20596", columns: ['Country', 'Yes (%)','No (%)'], datasetLiteral:"874", hasTrend: true}
                ]
            }
        ]
    },
    {
        literalTab: "20872",
        url: "initiatives-support",
        subTabs: [
            { 
                url:"awareness-raising",
                literalTab: "20873",
                chartType: [
                    {type: "osh-pulse", title: "20889", chart: "20164", chartIndicator: "461", sortByAnswer: ["value"], legend: "20890", columns:['Country'], datasetLiteral: "1025", hasTrend: false}
                ]
            },
            {
                url:"workers-consultation",
                literalTab: "20874",
                chartType: [
                    {type: "osh-pulse", title: "20891", chart: "20165", chartIndicator: "462", sortByAnswer: ["value"], legend: "20892", columns:['Country'], datasetLiteral: "1025", hasTrend: false}
                ]
            },
            /*{
                url:"information-and-training",
                literalTab: "20875",
                chartType: [
                    {type: "osh-pulse", title: "20893", chart: "20166", chartIndicator: "463", sortByAnswer: ["value"], legend: "20894", columns:['Country'], datasetLiteral: "1025", hasTrend: false}
                ]
            },*/
            {
                url:"access-to-counseling",
                literalTab: "20876",
                chartType: [
                    {type: "osh-pulse", title: "20895", chart: "20167", chartIndicator: "464", sortByAnswer: ["value"], legend: "20896", columns:['Country'], datasetLiteral: "1025", hasTrend: false}
                ]
            },
            {
                url:"comfortable",
                literalTab: "20877",
                chartType: [
                    {type: "osh-pulse", title: "20897", chart: "20168", chartIndicator: "465", answers: ['110','21','22','111','96'], sortByAnswer: ["110","21"], legend: "20898", columns:['Country'], datasetLiteral: "1025", hasTrend: false}
                ]
            },
            {
                url:"disclosing",
                literalTab: "20878",
                chartType: [
                    {type: "osh-pulse", title: "20899", chart: "20169", chartIndicator: "466", answers: ['110','21','22','111','96'], sortByAnswer: ["110","21"], legend: "20900", columns:['Country'], datasetLiteral: "1025", hasTrend: false}
                ]
            }
        ]
    }
]

export const physicalRiskTabs = [
    { 
        literalTab: "20654",
        url: "vibrations-loud-noise-and-temperature",
        chartType: [
            {type: "ewcs", chart:"20049", title: "20654", chartIndicator: '67', sector: null, answers: null, legend: null, datasetLiteral:"874"}
        ]
    },
    { 
        literalTab: "20655",
        url: "exposure-to-dangerous-substances",
        subTabs: [
        {
            literalTab: "24620",
            url: "smoke-powder-or-dust",
            chartType: [{type: "ewcs", chart:"20053", title: "22143", chartIndicator: "71", sector: null, answers: ["26", "27"], legend: "20598",sortByAnswer: ["26"],columns:['Country','At least ¼ of the time (%)','Less than ¼ of the time (%)'], datasetLiteral:"874"}]
        },
        {
            literalTab: "24621",
            url: "vapours", 
            chartType: [{type: "ewcs", chart:"20054", title: "22144", chartIndicator: "72", sector: null, answers: ["26", "27"], legend: "20599",sortByAnswer: ["26"],columns:['Country','At least ¼ of the time (%)','Less than ¼ of the time (%)'], datasetLiteral:"874"}]
        },
        {
            literalTab: "24622",
            url: "chemical-products", 
            chartType: [{type: "ewcs", chart:"20055", title: "22145", chartIndicator: "73", sector: null, answers: ["26", "27"], legend: "20600",sortByAnswer: ["26"],columns:['Country','At least ¼ of the time (%)','Less than ¼ of the time (%)'], datasetLiteral:"874"}]
        },
        {
            literalTab: "24623",
            url: "infectious-materials", 
            chartType: [{type: "ewcs", chart:"20056", title: "22146", chartIndicator: "74", sector: null, answers: ["26", "27"], legend: "20601",sortByAnswer: ["26"],columns:['Country','At least ¼ of the time (%)','Less than ¼ of the time (%)'], datasetLiteral:"874"}]
        }]
    },
    { 
        literalTab: "20656",
        url: "ergonomic-risks",
        chartType: [
            {type: "esener", chart:"20101", title: "20656", chartIndicator: '480', sector: null, answers: null, legend: null, datasetLiteral: "875"},
            {type: "ewcs", chart:"20080", title: "20656", chartIndicator: '90', sector: null, answers: null, legend: null, datasetLiteral:"874"}
        ]
    }
]

export const safetyRisksTab = [
    {
        literalTab: "20043",
        url: "fatal-accidents",
        subTabs: [
            {
                url: "operating-machine",
                literalTab: "20044",
                chartType: [{type: "ewcs", chart:"20109", title: "20052", chartIndicator: "393", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "hand-held-tools",
                literalTab: "20045",
                chartType: [{type: "ewcs", chart:"20110", title: "20053", chartIndicator: "394", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "driving-transport",
                literalTab: "20046",
                chartType: [{type: "ewcs", chart:"20111", title: "20054", chartIndicator: "395", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "handling-objects",
                literalTab: "20047",
                chartType: [{type: "ewcs", chart:"20112", title: "20055", chartIndicator: "396", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "carrying-by-hand",
                literalTab: "20048",
                chartType: [{type: "ewcs", chart:"20113", title: "20056", chartIndicator: "397", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "movement",
                literalTab: "20049",
                chartType: [{type: "ewcs", chart:"20114", title: "20057", chartIndicator: "398", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "presence",
                literalTab: "20050",
                chartType: [{type: "ewcs", chart:"20115", title: "20058", chartIndicator: "399", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "other",
                literalTab: "20051",
                chartType: [{type: "ewcs", chart:"20116", title: "20059", chartIndicator: "400", sector: null, answers: null, legend: "20060"}]
            }
        ]
    },
    {
        literalTab: "20042",
        url: "non-fatal-accidents",
        subTabs: [
            {
                url: "operating-machine",
                literalTab: "20044",
                chartType: [{type: "ewcs", chart:"20117", title: "20052", chartIndicator: "401", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "hand-held-tools",
                literalTab: "20045",
                chartType: [{type: "ewcs", chart:"20118", title: "20053", chartIndicator: "402", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "driving-transport",
                literalTab: "20046",
                chartType: [{type: "ewcs", chart:"20119", title: "20054", chartIndicator: "403", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "handling-objects",
                literalTab: "20047",
                chartType: [{type: "ewcs", chart:"20120", title: "20055", chartIndicator: "404", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "carrying-by-hand",
                literalTab: "20048",
                chartType: [{type: "ewcs", chart:"20121", title: "20056", chartIndicator: "405", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "movement",
                literalTab: "20049",
                chartType: [{type: "ewcs", chart:"20122", title: "20057", chartIndicator: "406", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "presence",
                literalTab: "20050",
                chartType: [{type: "ewcs", chart:"20123", title: "20058", chartIndicator: "407", sector: null, answers: null, legend: "20060"}]
            },
            {
                url: "other",
                literalTab: "20051",
                chartType: [{type: "ewcs", chart:"20124", title: "20059", chartIndicator: "408", sector: null, answers: null, legend: "20060"}]
            }
        ]
    }
]

export const digitalisationRisksTab = [
    {
        literalTab: "20870",
        url: "effects-digitalisation",
        subTabs: [
            {
                url: "pace-work",
                literalTab: "20837",
                chartType: [{type: "osh-pulse", chart:"20148", title: "20848", chartIndicator: "445", sector: null, answers: null, legend: "20849"}]
            },
            {
                url: "solitary-work",
                literalTab: "20838",
                chartType: [{type: "osh-pulse", chart:"20149", title: "20850", chartIndicator: "446", sector: null, answers: null, legend: "20851"}]
            },
            {
                url: "surveillance-work",
                literalTab: "20839",
                chartType: [{type: "osh-pulse", chart:"20150", title: "20852", chartIndicator: "447", sector: null, answers: null, legend: "20853"}]
            },
            {
                url: "workload",
                literalTab: "20840",
                chartType: [{type: "osh-pulse", chart:"20151", title: "20854", chartIndicator: "448", sector: null, answers: null, legend: "20855"}]
            },
            {
                url: "reduction-autonomy",
                literalTab: "20841",
                chartType: [{type: "osh-pulse", chart:"20152", title: "20856", chartIndicator: "449", sector: null, answers: null, legend: "20857"}]
            }
        ]
    },
    {
        literalTab: "20836",
        url: "use-digitalisation",
        subTabs: [
            {
                url: "automatic-allocation",
                literalTab: "20842",
                chartType: [{type: "osh-pulse", chart:"20153", title: "20858", chartIndicator: "450", sector: null, answers: null, legend: "20859"}]
            },
            {
                url: "performance-reviews",
                literalTab: "20843",
                chartType: [{type: "osh-pulse", chart:"20154", title: "20860", chartIndicator: "451", sector: null, answers: null, legend: "20861"}]
            },
            {
                url: "work-monitoring",
                literalTab: "20844",
                chartType: [{type: "osh-pulse", chart:"20155", title: "20862", chartIndicator: "452", sector: null, answers: null, legend: "20863"}]
            },
            {
                url: "environmental-monitoring",
                literalTab: "20845",
                chartType: [{type: "osh-pulse", chart:"20156", title: "20864", chartIndicator: "453", sector: null, answers: null, legend: "20865"}]
            },
            {
                url: "health-monitoring",
                literalTab: "20846",
                chartType: [{type: "osh-pulse", chart:"20157", title: "20866", chartIndicator: "454", sector: null, answers: null, legend: "20867"}]
            },
            {
                url: "employed-working-home",
                literalTab: "20847",
                chartType: [{type: "osh-pulse", chart:"20158", title: "20868", chartIndicator: "455", sector: null, answers: null, legend: "20869"}]
            }
        ]
    }
]

export const preventionInCompanies = [
    {
        url:"risk-assessment",
        literalTab: "20679",
        chartType: [
            {type: "sector", chart:"20102", title: "471", chartIndicator: "495", sector: ["2","3","4","5","6","7","18","14"], size: null, answers: ["1"], legend: "20603", selectLiteral: "20648"},
            {type: "establishment size", chart:"20102", title: "471", chartIndicator: "495", sector: null, "size":["7","8","14","10","11"], answers: ["1"], legend: "20602", selectLiteral: "20647"}
        ]
    },
    {
        url:"internal-or-external-ra",
        literalTab: "20680", 
        chartType: [{type: "esener", chart:"20103", title: "22148", chartIndicator: "496", sector: ["14"], answers: ["28", "29", "30"], legend: "20604", datasetLiteral: "875"}]
    },
    {
        url:"evaluated-aspects-in-risk-assessments",
        literalTab: "20681", 
        chartType: [{type: "ewcs", chart:"", title: "20681", chartIndicator: "", sector: null, answers: ["1", "2"], legend: "20605", datasetLiteral:"874"}]
    },
    {
        url:"training-in-osh",
        literalTab: "20682", 
        chartType: [{type: "esener", chart:"20104", title: "22149", chartIndicator: "561", sector: ["14"], answers: ["1", "2", "71"], legend: "20606", datasetLiteral: "875"}]
    },
    {
        url:"employees-participation-in-prevention",
        literalTab: "20683", 
        chartType: [
            {type: "sector", chart:"20105", title: "768", chartIndicator: "553", sector: ["2","3","4","5","6","7","18","14"], answers: ["1"], legend: "20607", selectLiteral: "20648"},
            {type: "establishment size", chart:"20105", title: "768", chartIndicator: "553", sector: null, "size":["7","8","14","10","11"], answers: ["1"], legend: "20608", selectLiteral: "20647"}
        ]
    },
]

export const oshCulture = [
    {
        url: "health-and-safety-discussed",
        literalTab: "20664",
        chartType: [
            {type: "esener", title: "22129", chart: "20091", chartIndicator: "559", sector: ["14"], answers: ["3","4","5","39","97", "98", "99"], sortByAnswer: ["97","98"], legend: "20570", columns:['Country','Regularly (%)','Occasionally (%)','Practically never (%)']}
        ]
    },
    { 
        url:"action-plan-to-prevent-stress",
        literalTab: "20665",
        chartType: [
            {type: "esener", title: "457", chart: "20092", chartIndicator: "519", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20571", columns:['Country','Yes (%)','No (%)']}
        ]
    }, 
    { 
        url:"procedure-against-bullying",
        literalTab: "20666",
        chartType: [
            {type: "esener", title: "458", chart: "20093", chartIndicator: "520", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20572", columns:['Country','Yes (%)','No (%)']}
        ]
    },
    { 
        url:"procedures-to-deal-with-threats",
        literalTab: "20667",
        chartType: [
            {type: "esener", title: "22132", chart: "20094", chartIndicator: "521", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20573", columns:['Country','Yes (%)','No (%)']}
        ]
    },
    { 
        url:"measures-to-reduce-work-pressure",
        literalTab: "20668",
        chartType: [
            {type: "esener", title: "22133", chart: "20095", chartIndicator: "522", sector: ["14"], answers: ["1", "2"], sortByAnswer: ["1"], legend: "20574", columns:['Country','Yes (%)','No (%)']}
        ]
    },
    { 
        url:"use-of-personal-protective-equipment",
        literalTab: "24616",
        chartType: [
            {type: "ewcs", title: "22126", chart: "20038", chartIndicator: "63", answers: ["6", "7", "32"], sortByAnswer: ["32", "7"], legend: "20575", columns:['Country','Yes and always (%)','Yes, but not required (%)','No, not required (%)']}
        ]
    },
    { 
		url:"information-about-risks",
        literalTab: "24617",
        chartType: [
            {type: "ewcs", title: "22127", chart: "20039", chartIndicator: "64", answers: ["8", "9"], sortByAnswer: ["8"], legend: "20576", columns:['Country','(very) Well informed (%)','Not very or not at all well informed (%)']}
																																				
        ]
    }
]

export const workAccidents = [
    {
        literalTab: "24614",
        url: "non-fatal-work-accidents",
        subTabs: [
            {
                url: "trends",
                literalTab: "20909",
                showCountrySelect: true,
                chart: {
                    id: 20022,
                    indicator: 53,
                    title: 310,
                    legend: "20565",
                    size: "medium",
                    type: 'line',
                    percentage: true
                }
            }, 
            {
                url: "sector",
                literalTab: "20910",
                sectorChart: true,
                showSectorSelect: true,
                chart: {
                    id: 20024,
                    indicator: "580",
                    title: "20912",
                    legend: "20913",
                    size: "medium"
                }
            },
            {
                url: "country",
                literalTab: "20911",
                sectorChart: true,
                showCountrySelect: true,
                chart: {
                    id: 20025,
                    indicator: "580",
                    title: "20914",
                    legend: "20915",
                    size: "medium"
                }
            }
        ]
    },
    { 
        url:"fatal-work-accidents",
        literalTab: "24615",
        subTabs: [
            {
                url: "trends",
                literalTab: "20902",
                chart: {
                    id: 20023,
                    indicator: 54,
                    title: 22196,
                    legend: 20566,
                    size: "large",
                    type: "column"
                }
            }, 
            {
                url: "sector",
                literalTab: "20903",
                sectorChart: true,
                showSectorSelect: true,
                chart: {
                    id: 20027,
                    indicator: "579",
                    title: 20905,
                    legend: 20906,
                    size: "large"
                }
            },
            {
                url: "country",
                literalTab: "20904",
                sectorChart: true,
                showCountrySelect: true,
                chart: {
                    id: 20028,
                    indicator: "579",
                    title: 20907,
                    legend: 20908,
                    size: "large"
                }
            }
        ]
    },
    { 
        url:"serious-non-fatal-work-accidents",
        literalTab: "20557",
        chart: {
            id: 20140,
            indicator: 422,
            title: 20558,
            legend: 20559,
            size: "large",
            type: "column"
        }
    }
]

export const workRelatedDiseasesTab = [
    {
        literalTab: "20380",
        type: "ilo",
        url: "who-ilo",
        subTabs: [
            { 
                literalTab: "20384",
                url: "prevalence-of-diseases",
                subTabs: [
                    {
                        literalTab: "20495",
                        url: "all-diseases",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20395", chartIndicator: "419", illness: "14", legend: "20396"},
                            {type: "deaths", chart: "20131", title: "20393", chartIndicator: "409", illness: "14", legend: "20394"}
                        ]
                    },
                    {
                        literalTab: "20496",
                        url: "asbestos-cancer",
                        tooltip: "20504",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20399", chartIndicator: "419", illness: "7", legend: "20442"},
                            {type: "deaths", chart: "20131", title: "20397", chartIndicator: "409", illness: "7", legend: "20398"}
                        ]
                    },
                    {
                        literalTab: "20497",
                        url: "chemical-cancers",
                        tooltip: "20505",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20445", chartIndicator: "419", illness: "9", legend: "20446"},
                            {type: "deaths", chart: "20131", title: "20443", chartIndicator: "409", illness: "9", legend: "20444"}
                        ]
                    },
                    {
                        literalTab: "20498",
                        url: "cvd",
                        tooltip: "20506",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20449", chartIndicator: "419", illness: "8", legend: "20450", yAxisMax: 800, step: 200},
                            {type: "deaths", chart: "20131", title: "20447", chartIndicator: "409", illness: "8", legend: "20448"}
                        ]
                    },
                    {
                        literalTab: "20499",
                        url: "injuries",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20453", chartIndicator: "419", illness: "5", legend: "20454"},
                            {type: "deaths", chart: "20131", title: "20451", chartIndicator: "409", illness: "5", legend: "20452"}
                        ]
                    },
                    {
                        literalTab: "20500",
                        url: "copd",
                        tooltip: "20507",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20457", chartIndicator: "419", illness: "10", legend: "20458"},
                            {type: "deaths", chart: "20131", title: "20455", chartIndicator: "409", illness: "10", legend: "20456"}
                        ]
                    },
                    {
                        literalTab: "20501",
                        url: "asthma",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20461", chartIndicator: "419", illness: "11", legend: "20462"},
                            {type: "deaths", chart: "20131", title: "20459", chartIndicator: "409", illness: "11", legend: "20460"}
                        ]
                    },
                    {
                        literalTab: "20502",
                        url: "hearing-loss",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20463", chartIndicator: "419", illness: "12", legend: "20464"}
                        ]
                    },
                    {
                        literalTab: "20503",
                        url: "back-neck-pain",
                        chartType: [
                            {type: "daly", chart:"20129", title: "20465", chartIndicator: "419", illness: "13", legend: "20466"}
                        ]
                    }
                ]
            },
            {
                literalTab: "20385",
                url: "disease-groups-per-country", 
                chartType: [
                    {type: "daly", chart:"20128", title: "20385", chartIndicator: "419", illness: ["5","7","8","9","10","11","12","13"], sector: null, legend: null },
                    {type: "deaths", chart:"20132", title: "20385", chartIndicator: "409", illness: ["5","7","8","9","10","11"], sector:null, legend: null }
                ]
            },
            {
                literalTab: "20386",
                url: "development-in-eu-countries",
                subTabs: [
                    {
                        literalTab: "20495",
                        url: "all-diseases",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20392", chartIndicator: "419", illness: "14", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20391", chartIndicator: "409", illness: "14", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20496",
                        url: "asbestos-cancer",
                        tooltip: "20504",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20531", chartIndicator: "419", illness: "7", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20530", chartIndicator: "409", illness: "7", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20497",
                        url: "chemical-cancers",
                        tooltip: "20505",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20533", chartIndicator: "419", illness: "9", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20532", chartIndicator: "409", illness: "9", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20498",
                        url: "cvd",
                        tooltip: "20506",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20535", chartIndicator: "419", illness: "8", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20534", chartIndicator: "409", illness: "8", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20499",
                        url: "injuries",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20537", chartIndicator: "419", illness: "5", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20536", chartIndicator: "409", illness: "5", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20500",
                        url: "copd",
                        tooltip: "20507",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20539", chartIndicator: "419", illness: "10", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20538", chartIndicator: "409", illness: "10", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20501",
                        url: "asthma",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20541", chartIndicator: "419", illness: "11", legend: "20492"},
                            {type: "deaths", chart: "20133", title: "20540", chartIndicator: "409", illness: "11", legend: "20491"}
                        ]
                    },
                    {
                        literalTab: "20502",
                        url: "hearing-loss",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20542", chartIndicator: "419", illness: "12", legend: "20492"}
                        ]
                    },
                    {
                        literalTab: "20503",
                        url: "back-neck-pain",
                        chartType: [
                            {type: "daly", chart:"20130", title: "20543", chartIndicator: "419", illness: "13", legend: "20492"}
                        ]
                    }
                ]
            }
        ]
    },
    {
        literalTab: "20383",
        type: "icoh",
        url: "icoh",
        subTabs: [
            {
                literalTab: "20388",
                url: "prevalence-of-diseases",
                subTabs: [
                    {
                        literalTab: "20508",
                        url: "all-diseases",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20469", chartIndicator: "421", illness:"14", legend: "20470"},
                            {type: "deaths", chart: "20137", title: "20467", chartIndicator: "420", illness:"14", legend: "20468"}
                        ]
                    },
                    {
                        literalTab: "20509",
                        url: "cancers",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20473", chartIndicator: "421", illness:"2", legend: "20474"},
                            {type: "deaths", chart: "20137", title: "20471", chartIndicator: "420", illness:"2", legend: "20472"}
                        ]
                    },
                    {
                        literalTab: "20510",
                        url: "cvd",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20477", chartIndicator: "421", illness:"8", legend: "20478"},
                            {type: "deaths", chart: "20137", title: "20475", chartIndicator: "420", illness:"8", legend: "20476"}
                        ]
                    },
                    {
                        literalTab: "20511",
                        url: "msds",
                        tooltip: "20514",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20481", chartIndicator: "421", illness:"16", legend: "20482"}
                        ]
                    },
                    {
                        literalTab: "20512",
                        url: "injuries",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20485", chartIndicator: "421", illness:"5", legend: "20486"},
                            {type: "deaths", chart: "20137", title: "20483", chartIndicator: "420", illness:"5", legend: "20484"}
                        ]
                    },
                    {
                        literalTab: "20776",
                        url: "psychosocial",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20777", chartIndicator: "421", illness:"17", legend: "20778"}
                        ]
                    },
                    {
                        literalTab: "20513",
                        url: "other",
                        chartType: [
                            {type: "daly", chart:"20134", title: "20489", chartIndicator: "421", illness:"15", legend: "20490"},
                            {type: "deaths", chart: "20137", title: "20487", chartIndicator: "420", illness:"15", legend: "20488"}
                        ]
                    }
                ]
            },
            {
                literalTab: "20389",
                url: "disease-groups-per-country", 
                chartType: [
                    {type: "daly", chart:"20135", title: "20385", chartIndicator: "421", illness: ["2", "5", "8", "15", "17", "16"], sector: null, legend: null },
                    {type: "deaths", chart:"20138", title: "20385", chartIndicator: "420", illness: ["2", "5", "8", "15", "16"], sector:null, legend: null }
                ]
            },
            {
                literalTab: "20390",
                url: "development-in-eu-countries",
                subTabs: [
                    {
                        literalTab: "20508",
                        url: "all-diseases",
                        chartType: [
                            {type: "daly", chart:"20136", title: "20545", chartIndicator: "421", illness:"14", legend: "20494"},
                            {type: "deaths", chart: "20139", title: "20544", chartIndicator: "420", illness:"14", legend: "20493"}
                        ]
                    },
                    {
                        literalTab: "20509",
                        url: "cancers",
                        chartType: [
                            {type: "daly", chart:"20136", title: "20547", chartIndicator: "421", illness: "2", legend: "20494"},
                            {type: "deaths", chart: "20139", title: "20546", chartIndicator: "420", illness: "2", legend: "20493"}
                        ]
                    },
                    {
                        literalTab: "20510",
                        url: "cvd",
                        chartType: [
                            {type: "daly", chart:"20136", title: "20549", chartIndicator: "421", illness: "8", legend: "20494"},
                            {type: "deaths", chart: "20139", title: "20548", chartIndicator: "420", illness: "8", legend: "20493"}
                        ]
                    },
                    {
                        literalTab: "20511",
                        url: "msds",
                        tooltip: "20514",
                        chartType: [
                            {type: "daly", chart:"20136", title: "20550", chartIndicator: "421", illness: "16", legend: "20494"}
                        ]
                    },
                    {
                        literalTab: "20512",
                        url: "injuries",
                        chartType: [
                            {type: "daly", chart:"20136", title: "20552", chartIndicator: "421", illness: "5", legend: "20494"},
                            {type: "deaths", chart: "20139", title: "20551", chartIndicator: "420", illness: "5", legend: "20493"}
                        ]
                    },
                    {
                        literalTab: "20513",
                        url: "other",
                        chartType: [
                            {type: "daly", chart:"20136", title: "20554", chartIndicator: "421", illness: "15", legend: "20494"},
                            {type: "deaths", chart: "20139", title: "20553", chartIndicator: "420", illness: "15", legend: "20493"}
                        ]
                    }
                ]
            }
        ]
    }
]

export const reportedHealthProblemsTabs = [
    {
        literalTab: "20931",
        url: "general",
        chartType: [{
            chart: '20030',
            chartIndicator: '582',
            title: '20938',
            legend: '20939'
        }],
        showCountrySelect: true
    },
    {
        literalTab: "20932",
        url: "gender",
        chartType: [{
            chart: '20031',
            chartIndicator: '582',
            title: '20940',
            legend: '20941'
        }]
    },
    {
        literalTab: "20933",
        url: "age-group",
        chartType: [{
            chart: '20032',
            chartIndicator: '582',
            title: '20942',
            legend: '20943'
        }]
    },
    {
        literalTab: "20934",
        url: "education-age",
        chartType: [{
            chart: '20033',
            chartIndicator: '582',
            title: '20944',
            legend: '20945'
        }]
    },
    {
        literalTab: "20935",
        url: "occupation",
        chartType: [{
            chart: '20034',
            chartIndicator: '582',
            title: '20946',
            legend: '20947'
        }]
    },
    {
        literalTab: "20936",
        url: "safety-health-prevention-culture",
        chartType: [{
            chart: '20035',
            chartIndicator: '582',
            title: '20948',
            legend: '20949',
            split: 'safety_health'
        }]
    },
    {
        literalTab: "20937",
        url: "activity-sector",
        chartType: [{
            chart: '20036',
            chartIndicator: '582',
            title: '20950',
            legend: '20951'
        }],
        showSectorSelect: true
    }
]

export const enforcementAuthoritiesTabs = [
    {
        literalTab: '24624',
        url: 'authority',
        indicator: '76'
    },
    {
        literalTab: '24625',
        url: 'scope-of-the-labor-inspection',
        indicator: '77'
    },
    {
        literalTab: '24626',
        url: 'inspector-powers',
        indicator: '78'
    },
    {
        literalTab: '24627',
        url: 'strategy-plan',
        indicator: '79'
    }
]

export const enforcementCapacityTabs = [
    {
        literalTab: "20783",
        url: "inspector-activities",
        subTabs: [
			{
				literalTab: "20785",
				url: "staff-li-authorities",
				tooltip: "20786",
				chartType: [{
					title: '20786', chart: '20141', legend: '20787', asterisk: '20824', chartIndicator: '431', percentage: false
				}]
			},
			{
				literalTab: "20788",
				url: "labour-inspectors",
				tooltip: "20789",
				chartType: [{
					title: '20789', chart: '20142', legend: '20790', asterisk: '20825', chartIndicator: '432', percentage: false
				}]
			},
			{
				literalTab: "20791",
				url: "osh-inspections",
				tooltip: "20792",
				chartType: [{
					title: '20792', chart: '20143', legend: '20793', asterisk: '20826', chartIndicator: '433', percentage: false
				}]
			},
			{
				literalTab: "20794",
				url: "total-enterprises-visited",
				tooltip: "20795",
				chartType: [{
					title: '20795', chart: '20144', legend: '20796', asterisk: '20827', chartIndicator: '434', percentage: true
				}]
			},
			{
				literalTab: "20797",
				url: "share-enterprises-visited",
				tooltip: "20798",
				chartType: [{
					title: '20798', chart: '20145', legend: '20799', asterisk: '20828', chartIndicator: '435', size: ['16','17','18','19'], splitName: "20243", percentage: true
				}]
			},
			{
				literalTab: '20692',
				url: 'establishments-inspected',
				chartType: [{
					title: '20692', subTitle: '20693', chart: '20107', legend: '20831', chartIndicator: '472', sector: ['14'], answers: ['1', '2']
				}]
			}
		]
    },
    {
        literalTab: "20784",
        url: "sanctions-impact",
        mapChart: '20146',
        mapIndicators: [{
            id: '436',
            literalId: '20800',
            footNote: '20829'
        },{
            id: '437',
            literalId: '20801'
        },{
            id: '438',
            literalId: '20802'
        },{
            id: '439',
            literalId: '20803',
            footNote: '20830'
        },{
            id: '440',
            literalId: '20804'
        }]
    }
]